export default {
  state: {
    PopularQueriesDeskbarInputService: {
      Волосы: "Hair",
      Депиляция: "Depilation",
      Массаж: "Massage",
      Ногти: "Nails",
      Лицо: "Face",
      Тело: "Body",
      Мужчинам: "For men",
    },
    AllQueriesDeskbarInputService: {
      Волосы: "Hair",
      Депиляция: "Depilation",
      Массаж: "Massage",
      Ногти: "Nails",
      Лицо: "Face",
      Тело: "Body",
      Мужчинам: "For men",
      Автозагар: "Self-tanning",
      "Антистрессовый массаж": "Anti-stress massage",
      "Антицеллюлитный массаж": "Anti-cellulite massage",
      "Аппаратный маникюр": "Hardware manicure",
      "Бикини-дизайн": "Bikini design",
      "Блеск-тату": "Glitter tattoo",
      "Вечерний макияж": "Evening make-up",
      "Вечерняя прическа": "Evening hairstyle",
      "Восковая эпиляция бровей": "Eyebrow waxing",
      "Восковая эпиляция для мужчин": "Wax hair removal for men",
      "Восстановительный массаж": "Recovery massage",
      "Выравнивание ногтевой пластины": "Alignment of the nail plate",
      "Горячий маникюр": "Hot manicure",
      "Градиент на ногтях": "Gradient on nails",
      "Депиляция воском и шугаринг": "Waxing and sugaring",
      "Депиляция воском: бедра": "Waxing:thighs",
      "Депиляция воском: брови": "Waxing:eyebrows",
      "Депиляция воском: глубокое бикини": "Waxing:deep bikini",
      "Депиляция воском: классическое бикини": "Waxing:classic bikini",
      "Депиляция воском: ноги полностью": "Waxing:full legs",
      "Депиляция воском: подмышки": "Waxing:armpits",
      "Депиляция воском: руки": "Waxing:hands",
      "Депиляция воском: усики": "Waxing:antennae",
      "Депиляция воском: ягодицы": "Waxing:buttocks",
      "Детская стрижка": "Childrens haircut",
      "Дневной макияж": "Day Makeup",
      "Европейский маникюр": "European manicure",
      "Женская стрижка": "Womens haircut",
      "Из тёмного цвета в блонд": "Dark to Blond",
      "Классические маски для лица": "Classic face masks",
      "Классический маникюр": "Classic manicure",
      "Классический массаж": "Classic massage",
      "Колорирование волос": "Hair coloring",
      "Комбинированный маникюр ": "Combined manicure",
      "Коррекция бровей": "Eyebrow shaping",
      "Коррекция наращенных ногтей": "Correction of extended nails",
      "Креативный макияж": "Creative makeup",
      Криолиполиз: "Cryolipolysis",
      "Ламинирование ногтей": "Nail lamination",
      "Лечебный массаж": "Massotherapy",
      "Лечение целлюлита": "Cellulite treatment",
      "Лимфодренажный массаж": "Lymphatic drainage massage",
      "Лунный маникюр": "Moon Manicure",
      "Макияж для фотосессии": "Makeup for a photo shoot",
      "Маникюр с покрытием гель-лаком": "Gel polish manicure",
      "Маникюр с покрытием ногтей лаком": "Manicure with nail polish",
      Маникюр: "Manicure",
      "Мелирование волос": "Hair highlights",
      "Мужская бразильская сушка феном": "Brazilian hair dryer for men",
      "Мужская стрижка": "Mens haircut",
      "Мужские маски для лица": "Mens face masks",
      "Наращивание ногтей акрилом": "Acrylic nail extension",
      "Наращивание ресниц": "Eyelash Extension",
      "Обезболивание зоны при удалении волос":
        "Anesthesia of the area during hair removal",
      "Обертывания для тела": "Body wraps",
      "Окрашивание бровей и ресниц": "Coloring of eyebrows and eyelashes",
      "Окрашивание волос в один тон": "Coloring hair in one tone",
      "Окрашивание волос для мужчин": "Hair coloring for men",
      "Окрашивание волос краской клиента": "Hair dyeing with clients dye",
      "Окрашивание корней волос": "Hair coloring",
      "Отшелушивающие процедуры для тела": "Exfoliating body treatments",
      "Плетение кос": "Weaving braids",
      "Ремонт ногтя": "Nail repair",
      "Репетиция свадебного макияжа": "Rehearsal of wedding makeup",
      "Ровнение бровей": "Smoothing eyebrows",
      "Ручная роспись ногтей": "Hand-painted nails",
      "Свадебная прическа": "Wedding hairstyle",
      "Свадебный макияж": "Wedding make-up",
      "Снятие гель-лака с ногтей на руках":
        "Removing gel polish from fingernails",
      "Снятие наращенных ногтей": "Removal of extended nails",
      "Создание прически": "Hairstyling",
      "Спортивный массаж": "Sports massage",
      "Стразы на ногтях": "Rhinestones on the nails",
      "Стрижка и бритье бороды": "Trimming and shaving a beard",
      "Стрижка челки": "Haircut bangs",
      "Толстокишечная гидротерапия": "Colon hydrotherapy",
      "Тонирование волос": "Hair tinting",
      "Укладка волос после окрашивания": "Hair styling after coloring",
      "Укладка волос после стрижки": "Hair styling after cutting",
      "Укладка волос средней длины": "Medium length hair styling",
      "Укладка коротких волос": "Styling short hair",
      "Укладка свадебная": "Wedding styling",
      "Французский маникюр": "French manicure",
      "Химическая завивка волос": "Permed hair",
      "Шугаринг: глубокое бикини": "Shugaring:deep bikini",
      "Шугаринг: голени": "Shugaring:shins",
      "Шугаринг: классическое бикини Блеск-тату":
        "Shugaring:classic bikini Glitter tattoo",
      "Шугаринг: ноги полностью": "Shugaring:legs completely",
      "Шугаринг: подмышки": "Shugaring:armpits",
      "Шугаринг: руки": "Shugaring:hands",
      "Шугаринг: усики": "Shugaring:antennae",
      "Шугаринг: ягодицы": "Shugaring:buttocks",
      "Японский маникюр": "Japanese manicure",
    },
    BaseHeaderCategories: [
      {
        name: "Волосы",
        value: [
          { name: "Вечерняя прическа", to: "Evening hairstyle" },
          { name: "Детская стрижка", to: "Childrens haircut" },
          { name: "Женская стрижка", to: "Womens haircut" },
          { name: "Из тёмного цвета в блонд", to: "Dark to Blond" },
          { name: "Колорирование волос", to: "Hair coloring" },
          { name: "Мелирование волос", to: "Hair highlights" },
          { name: "Мужская стрижка", to: "Mens haircut" },
          {
            name: "Окрашивание волос в один тон",
            to: "Coloring hair in one tone",
          },
          {
            name: "Окрашивание волос краской клиента",
            to: "Hair dyeing with clients dye",
          },
          { name: "Окрашивание корней волос", to: "Hair coloring" },
          { name: "Плетение кос", to: "Weaving braids" },
          { name: "Свадебная прическа", to: "Wedding hairstyle" },
          { name: "Создание прически", to: "Hairstyling" },
          { name: "Стрижка челки", to: "Haircut bangs" },
          { name: "Тонирование волос", to: "Hair tinting" },
          {
            name: "Укладка волос после окрашивания",
            to: "Hair styling after coloring",
          },
          {
            name: "Укладка волос после стрижки",
            to: "Hair styling after cutting",
          },
          {
            name: "Укладка волос средней длины",
            to: "Medium length hair styling",
          },
          { name: "Укладка коротких волос", to: "Styling short hair" },
          { name: "Укладка свадебная", to: "Wedding styling" },
          { name: "Химическая завивка волос", to: "Permed hair" },
        ],
      },
      {
        name: "Депиляция",
        value: [
          { name: "Бикини-дизайн", to: "Bikini Design" },
          { name: "Блеск-тату", to: "Glitter Tattoo" },
          { name: "Депиляция воском и шугаринг", to: "Waxing and sugaring" },
          { name: "Депиляция воском: бедра", to: "Waxing:thighs" },
          { name: "Депиляция воском: брови", to: "Waxing:eyebrows" },
          {
            name: "Депиляция воском: глубокое бикини",
            to: "Waxing:deep bikini",
          },
          {
            name: "Депиляция воском: классическое бикини",
            to: "Waxing:Classic Bikini",
          },
          { name: "Депиляция воском: ноги полностью", to: "Waxing:full legs" },
          { name: "Депиляция воском: подмышки", to: "Waxing:armpits" },
          { name: "Депиляция воском: руки", to: "Waxing:hands" },
          { name: "Депиляция воском: усики", to: "Waxing:antennae" },
          { name: "Депиляция воском: ягодицы", to: "Waxing:buttocks" },
          {
            name: "Обезболивание зоны при удалении волос",
            to: "Anesthesia of the area during hair removal",
          },
          { name: "Шугаринг: глубокое бикини", to: "Shugaring:deep bikini" },
          { name: "Шугаринг: голени", to: "Shugaring:shins" },
          {
            name: "Шугаринг: классическое бикини Блеск-тату",
            to: "Shugaring:classic bikini Glitter tattoo",
          },
          { name: "Шугаринг: ноги полностью", to: "Shugaring:legs completely" },
          { name: "Шугаринг: подмышки", to: "Shugaring:armpits" },
          { name: "Шугаринг: руки", to: "Shugaring:hands" },
          { name: "Шугаринг: усики", to: "Shugaring:antennae" },
          { name: "Шугаринг: ягодицы", to: "Shugaring:buttocks" },
        ],
      },
      {
        name: "Массаж",
        value: [
          { name: "Антистрессовый массаж", to: "Anti-stress massage" },
          { name: "Антицеллюлитный массаж", to: "Anti-cellulite massage" },
          { name: "Восстановительный массаж", to: "Recovery massage" },
          { name: "Классический массаж", to: "Classic massage" },
          { name: "Лечебный массаж", to: "Massotherapy" },
          { name: "Лимфодренажный массаж", to: "Lymphatic drainage massage" },
          { name: "Спортивный массаж", to: "Sports massage" },
        ],
      },
      {
        name: "Ногти",
        value: [
          { name: "Аппаратный маникюр", to: "Hardware manicure" },
          {
            name: "Выравнивание ногтевой пластины",
            to: "Alignment of the nail plate",
          },
          { name: "Горячий маникюр", to: "Hot Manicure" },
          { name: "Градиент на ногтях", to: "Gradient on nails" },
          { name: "Европейский маникюр", to: "European manicure" },
          { name: "Классический маникюр", to: "Classic manicure" },
          { name: "Комбинированный маникюр ", to: "Combined manicure" },
          {
            name: "Коррекция наращенных ногтей",
            to: "Correction of extended nails",
          },
          { name: "Ламинирование ногтей", to: "Nail lamination" },
          { name: "Лунный маникюр", to: "Moon Manicure" },
          { name: "Маникюр с покрытием гель-лаком", to: "Gel polish manicure" },
          {
            name: "Маникюр с покрытием ногтей лаком",
            to: "Manicure with nail polish",
          },
          { name: "Маникюр", to: "Manicure" },
          { name: "Наращивание ногтей акрилом", to: "Acrylic nail extension" },
          { name: "Ремонт ногтя", to: "Nail repair" },
          { name: "Ручная роспись ногтей", to: "Hand-painted nails" },
          {
            name: "Снятие гель-лака с ногтей на руках",
            to: "Removing gel polish from fingernails",
          },
          { name: "Снятие наращенных ногтей", to: "Removal of extended nails" },
          { name: "Стразы на ногтях", to: "Rhinestones on the nails" },
          { name: "Французский маникюр", to: "French manicure" },
          { name: "Японский маникюр", to: "Japanese manicure" },
        ],
      },
      {
        name: "Лицо",
        value: [
          { name: "Вечерний макияж", to: "Evening make-up" },
          { name: "Восковая эпиляция бровей", to: "Eyebrow waxing" },
          { name: "Дневной макияж", to: "Day Makeup" },
          { name: "Классические маски для лица", to: "Classic Face Masks" },
          { name: "Коррекция бровей", to: "Eyebrow shaping" },
          { name: "Креативный макияж", to: "Creative Makeup" },
          { name: "Макияж для фотосессии", to: "Makeup for a photo shoot" },
          { name: "Наращивание ресниц", to: "Eyelash Extension" },
          {
            name: "Окрашивание бровей и ресниц",
            to: "Coloring of eyebrows and eyelashes",
          },
          {
            name: "Репетиция свадебного макияжа",
            to: "Rehearsal of wedding makeup",
          },
          { name: "Ровнение бровей", to: "Smoothing eyebrows" },
          { name: "Свадебный макияж", to: "Wedding make-up" },
        ],
      },
      {
        name: "Тело",
        value: [
          { name: "Автозагар", to: "Self-tanning" },
          { name: "Криолиполиз", to: "Cryolipolysis" },
          { name: "Лечение целлюлита", to: "Cellulite Treatment" },
          { name: "Обертывания для тела", to: "Body Wraps" },
          {
            name: "Отшелушивающие процедуры для тела",
            to: "Exfoliating Body Treatments",
          },
          { name: "Толстокишечная гидротерапия", to: "Colon hydrotherapy" },
        ],
      },
      {
        name: "Мужчинам",
        value: [
          {
            name: "Восковая эпиляция для мужчин",
            to: "Wax hair removal for men",
          },
          {
            name: "Мужская бразильская сушка феном",
            to: "Brazilian hair dryer for men",
          },
          { name: "Мужская стрижка", to: "Mens haircut" },
          { name: "Мужские маски для лица", to: "Mens face masks" },
          { name: "Окрашивание волос для мужчин", to: "Hair coloring for men" },
          {
            name: "Стрижка и бритье бороды",
            to: "Trimming and shaving a beard",
          },
        ],
      },
    ],
    BaseHeaderCategoriesForPartners: [
      {
        name: "Возможности",
        to: "/partners/capabilities",
      },
      {
        name: "Наши партнёры",
        to: "/partners/partners",
      },
      {
        name: "Тарифы",
        to: "/partners/tariffs",
      },
      {
        name: "Ресурсы",
        to: "/partners/resources",
      },
    ],
    BaseFooterCategories: [
      {
        name: "Контакты",
        value: [
          { name: "Центр поддержки", href: "/" },
          { name: "Связь с нами", href: "/" },
        ],
      },
      {
        name: "Услуги для клиентов",
        value: [
          { name: "Забронировать место в салоне", href: "/" },
          { name: "Статьи о здоровье и красоте", href: "/" },
          { name: "Рекомендовать салон", href: "/" },
        ],
      },
      {
        name: "Партнёрство",
        value: [
          { name: "Начать сотрудничать", href: "/partners/registration" },
          { name: "Список наших партнёров", href: "/" },
          { name: "Справка партнёрства", href: "/" },
        ],
      },
      {
        name: "Компания",
        value: [
          { name: "О нас", href: "/" },
          { name: "Пользовательское соглашение", href: "/" },
        ],
      },
    ],
    BaseFooterCategoriesForPartners: [
      {
        name: "Возможноости",
        value: [
          { name: "Как всё работает", href: "/partners" },
          { name: "Почему comfortreat?", href: "/partners" },
        ],
      },
      {
        name: "Наши партнёры",
        value: [
          { name: "Список наших партнёров", href: "/partners" },
          { name: "Справка партнёрства", href: "/partners" },
        ],
      },
      {
        name: "Компания",
        value: [
          { name: "О нас", href: "/partners" },
          { name: "Пользовательское соглашение", href: "/partners" },
        ],
      },
      {
        name: "Ресурсы comfortreat",
        value: [
          { name: "FAQ", href: "/partners" },
          { name: "Блог", href: "/partners" },
        ],
      },
    ],
    BaseAdvantages: [
      {
        source: "price.svg",
        title: "Умные цены",
        subtitle: "Мы стараемся делать \n сервис доступным для всех",
      },
      {
        source: "bron.svg",
        title: "Бронируй 24/7",
        subtitle: "Занимайте свободные записи \n в удобное для вас время",
      },
      {
        source: "globus.svg",
        title: "Широкий выбор",
        subtitle: "С нами сотрудничают более 1000 салонов красоты",
      },
    ],
    MainPageBlogCardPost: [
      {
        name: "Владеете салоном, \n но всё ещё не с нами?",
        description:
          "Наша задача - не только упростить жизнь каждому, кто захочет посетить салон красоты, но и поддержать исполнителей данных услуг",
        btntext: "Узнать подробнее",
        href: "/partners/registration",
        source: "bg-salon.png",
      },
      {
        name: "Новинки моды 2021",
        description:
          "Новинки мировой индустрии красоты, которые вызывали наибольший отклик у людей в этом году! \n Вперёд к трендам!",
        btntext: "Мне интересно",
        href: "/",
        source: "bg-moda.png",
      },
    ],
    PopularQueriesDeskbarInputCity: [
      {
        value: "г Москва",
        suggestion: {
          value: "г Москва",
          unrestricted_value: "г Москва",
          data: {
            postal_code: null,
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
            region_kladr_id: "7700000000000",
            region_iso_code: "RU-MOW",
            region_with_type: "г Москва",
            region_type: "г",
            region_type_full: "город",
            region: "Москва",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
            city_kladr_id: "7700000000000",
            city_with_type: "г Москва",
            city_type: "г",
            city_type_full: "город",
            city: "Москва",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
            fias_code: "7700000000000000000",
            fias_level: "1",
            fias_actuality_state: "0",
            kladr_id: "7700000000000",
            geoname_id: "524894",
            capital_marker: "0",
            okato: "45000000000",
            oktmo: "45000000",
            tax_office: "7700",
            tax_office_legal: "7700",
            timezone: null,
            geo_lat: "55.75396",
            geo_lon: "37.620393",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: null,
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Санкт-Петербург",
        suggestion: {
          value: "г Санкт-Петербург",
          data: {
            postal_code: "190000",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "c2deb16a-0330-4f05-821f-1d09c93331e6",
            region_kladr_id: "7800000000000",
            region_iso_code: "RU-SPE",
            region_with_type: "г Санкт-Петербург",
            region_type: "г",
            region_type_full: "город",
            region: "Санкт-Петербург",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "c2deb16a-0330-4f05-821f-1d09c93331e6",
            city_kladr_id: "7800000000000",
            city_with_type: "г Санкт-Петербург",
            city_type: "г",
            city_type_full: "город",
            city: "Санкт-Петербург",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "c2deb16a-0330-4f05-821f-1d09c93331e6",
            fias_code: "7800000000000000000",
            fias_level: "1",
            fias_actuality_state: "0",
            kladr_id: "7800000000000",
            geoname_id: "498817",
            capital_marker: "0",
            okato: "40000000000",
            oktmo: "40000000",
            tax_office: "7800",
            tax_office_legal: "7800",
            timezone: null,
            geo_lat: "59.939084",
            geo_lon: "30.315879",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: null,
            qc_complete: null,
            qc_house: null,
            history_values: ["г Ленинград"],
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Новосибирск",
        unrestricted_value: "630000, Новосибирская обл, г Новосибирск",
        suggestion: {
          value: "г Новосибирск",
          data: {
            postal_code: "630000",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "1ac46b49-3209-4814-b7bf-a509ea1aecd9",
            region_kladr_id: "5400000000000",
            region_iso_code: "RU-NVS",
            region_with_type: "Новосибирская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Новосибирская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "8dea00e3-9aab-4d8e-887c-ef2aaa546456",
            city_kladr_id: "5400000100000",
            city_with_type: "г Новосибирск",
            city_type: "г",
            city_type_full: "город",
            city: "Новосибирск",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "8dea00e3-9aab-4d8e-887c-ef2aaa546456",
            fias_code: "5400000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "5400000100000",
            geoname_id: "1496747",
            capital_marker: "2",
            okato: "50401000000",
            oktmo: "50701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "55.028141",
            geo_lon: "82.921117",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Екатеринбург",
        suggestion: {
          value: "г Екатеринбург",
          unrestricted_value: "Свердловская обл, г Екатеринбург",
          data: {
            postal_code: null,
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "92b30014-4d52-4e2e-892d-928142b924bf",
            region_kladr_id: "6600000000000",
            region_iso_code: "RU-SVE",
            region_with_type: "Свердловская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Свердловская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "2763c110-cb8b-416a-9dac-ad28a55b4402",
            city_kladr_id: "6600000100000",
            city_with_type: "г Екатеринбург",
            city_type: "г",
            city_type_full: "город",
            city: "Екатеринбург",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "2763c110-cb8b-416a-9dac-ad28a55b4402",
            fias_code: "6600000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "6600000100000",
            geoname_id: "1486209",
            capital_marker: "2",
            okato: "65401000000",
            oktmo: "65701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "56.838607",
            geo_lon: "60.605514",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: ["г Свердловск"],
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Казань",
        suggestion: {
          value: "г Казань",
          unrestricted_value: "Респ Татарстан, г Казань",
          data: {
            postal_code: null,
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "0c089b04-099e-4e0e-955a-6bf1ce525f1a",
            region_kladr_id: "1600000000000",
            region_iso_code: "RU-TA",
            region_with_type: "Респ Татарстан",
            region_type: "Респ",
            region_type_full: "республика",
            region: "Татарстан",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "93b3df57-4c89-44df-ac42-96f05e9cd3b9",
            city_kladr_id: "1600000100000",
            city_with_type: "г Казань",
            city_type: "г",
            city_type_full: "город",
            city: "Казань",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "93b3df57-4c89-44df-ac42-96f05e9cd3b9",
            fias_code: "1600000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "1600000100000",
            geoname_id: "551487",
            capital_marker: "2",
            okato: "92401000000",
            oktmo: "92701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "55.794438",
            geo_lon: "49.111451",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Нижний Новгород",
        suggestion: {
          value: "г Нижний Новгород",
          unrestricted_value: "603000, Нижегородская обл, г Нижний Новгород",
          data: {
            postal_code: "603000",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "88cd27e2-6a8a-4421-9718-719a28a0a088",
            region_kladr_id: "5200000000000",
            region_iso_code: "RU-NIZ",
            region_with_type: "Нижегородская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Нижегородская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "555e7d61-d9a7-4ba6-9770-6caa8198c483",
            city_kladr_id: "5200000100000",
            city_with_type: "г Нижний Новгород",
            city_type: "г",
            city_type_full: "город",
            city: "Нижний Новгород",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "555e7d61-d9a7-4ba6-9770-6caa8198c483",
            fias_code: "5200000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "5200000100000",
            geoname_id: "520555",
            capital_marker: "2",
            okato: "22401000000",
            oktmo: "22701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "56.324133",
            geo_lon: "44.005299",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: ["г Горький"],
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Челябинск",
        suggestion: {
          value: "г Челябинск",
          unrestricted_value: "454000, Челябинская обл, г Челябинск",
          data: {
            postal_code: "454000",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: "Уральский",
            region_fias_id: "27eb7c10-a234-44da-a59c-8b1f864966de",
            region_kladr_id: "7400000000000",
            region_iso_code: "RU-CHE",
            region_with_type: "Челябинская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Челябинская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "a376e68d-724a-4472-be7c-891bdb09ae32",
            city_kladr_id: "7400000100000",
            city_with_type: "г Челябинск",
            city_type: "г",
            city_type_full: "город",
            city: "Челябинск",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "a376e68d-724a-4472-be7c-891bdb09ae32",
            fias_code: "74000001000000000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "7400000100000",
            geoname_id: "1508291",
            capital_marker: "2",
            okato: "75401000000",
            oktmo: "75701000001",
            tax_office: "7400",
            tax_office_legal: "7400",
            timezone: null,
            geo_lat: "55.1602624",
            geo_lon: "61.4008078",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Самара",
        suggestion: {
          value: "г Самара",
          unrestricted_value: "Самарская обл, г Самара",
          data: {
            postal_code: null,
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "df3d7359-afa9-4aaa-8ff9-197e73906b1c",
            region_kladr_id: "6300000000000",
            region_iso_code: "RU-SAM",
            region_with_type: "Самарская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Самарская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "bb035cc3-1dc2-4627-9d25-a1bf2d4b936b",
            city_kladr_id: "6300000100000",
            city_with_type: "г Самара",
            city_type: "г",
            city_type_full: "город",
            city: "Самара",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "bb035cc3-1dc2-4627-9d25-a1bf2d4b936b",
            fias_code: "6300000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "6300000100000",
            geoname_id: "499099",
            capital_marker: "2",
            okato: "36401000000",
            oktmo: "36701000",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "53.195096",
            geo_lon: "50.106868",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Омск",
        suggestion: {
          value: "г Омск",
          unrestricted_value: "644000, Омская обл, г Омск",
          data: {
            postal_code: "644000",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "05426864-466d-41a3-82c4-11e61cdc98ce",
            region_kladr_id: "5500000000000",
            region_iso_code: "RU-OMS",
            region_with_type: "Омская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Омская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "140e31da-27bf-4519-9ea0-6185d681d44e",
            city_kladr_id: "5500000100000",
            city_with_type: "г Омск",
            city_type: "г",
            city_type_full: "город",
            city: "Омск",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "140e31da-27bf-4519-9ea0-6185d681d44e",
            fias_code: "5500000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "5500000100000",
            geoname_id: "1496153",
            capital_marker: "2",
            okato: "52401000000",
            oktmo: "52701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "54.984912",
            geo_lon: "73.367525",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
      {
        value: "г Ростов-на-Дону",
        suggestion: {
          value: "г Ростов-на-Дону",
          unrestricted_value: "Ростовская обл, г Ростов-на-Дону",
          data: {
            postal_code: null,
            country: "Россия",
            country_iso_code: "RU",
            federal_district: null,
            region_fias_id: "f10763dc-63e3-48db-83e1-9c566fe3092b",
            region_kladr_id: "6100000000000",
            region_iso_code: "RU-ROS",
            region_with_type: "Ростовская обл",
            region_type: "обл",
            region_type_full: "область",
            region: "Ростовская",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5",
            city_kladr_id: "6100000100000",
            city_with_type: "г Ростов-на-Дону",
            city_type: "г",
            city_type_full: "город",
            city: "Ростов-на-Дону",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: null,
            city_district_type: null,
            city_district_type_full: null,
            city_district: null,
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: null,
            street_kladr_id: null,
            street_with_type: null,
            street_type: null,
            street_type_full: null,
            street: null,
            house_fias_id: null,
            house_kladr_id: null,
            house_type: null,
            house_type_full: null,
            house: null,
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: null,
            square_meter_price: null,
            flat_price: null,
            postal_box: null,
            fias_id: "c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5",
            fias_code: "6100000100000000000",
            fias_level: "4",
            fias_actuality_state: "0",
            kladr_id: "6100000100000",
            geoname_id: "501175",
            capital_marker: "2",
            okato: "60401000000",
            oktmo: "60701000001",
            tax_office: null,
            tax_office_legal: null,
            timezone: null,
            geo_lat: "47.222531",
            geo_lon: "39.718705",
            beltway_hit: null,
            beltway_distance: null,
            metro: null,
            qc_geo: "4",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: null,
            qc: null,
          },
        },
      },
    ],
  },
};
